/**
 * "Verified Student" badge — shown next to a user's name when their signup
 * email is from a recognized academic domain (.edu, .ac.uk, etc.). It's a
 * status signal, not a gate. Driven by the `verifiedStudent` flag on ApiUser /
 * LeaderboardEntry.
 */

export function VerifiedBadge({ className = '', size = 14 }: { className?: string; size?: number }) {
  return (
    <span
      className={`inline-flex shrink-0 align-middle text-squishy-primary ${className}`}
      title="Verified Student"
      aria-label="Verified Student"
      role="img"
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        {/* Seal: scalloped circle + check, mirroring the familiar verified mark */}
        <path d="M12 1.5l2.39 1.74 2.95-.02 1.0 2.78 2.4 1.71-.92 2.8.92 2.8-2.4 1.71-1.0 2.78-2.95-.02L12 22.5l-2.39-1.74-2.95.02-1.0-2.78-2.4-1.71.92-2.8-.92-2.8 2.4-1.71 1.0-2.78 2.95.02L12 1.5z" />
        <path
          d="M10.6 15.4l-3.1-3.1 1.4-1.4 1.7 1.7 4.1-4.1 1.4 1.4-5.5 5.5z"
          fill="#fff"
        />
      </svg>
    </span>
  );
}
